export var PAGE_NAME = {
    COMPLETE: 'complete',
    ERROR: 'error',
    START: 'start'
};
export var DEFAULTS = {
    CUSTOMER_TYPE: 'consumer',
    DEVICE: '<mobi/desk/tab>',
    ERROR_MESSAGE: '',
    MESSAGE: '',
    PAGE_FUNCTION: '',
    PAGE_KIND: '',
    PAGE_NAME: '',
    PNL: 'vista',
    PRODUCT: 'generic',
    SITE_IDENTIFIER: 'vista',
    SUB_FUNCTION: ''
};
